import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNext = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "14px",
	height: "14px",
	viewBox: "0 0 17.581 11.18",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "keyboard_backspace_black_24dp_1_",
		"data-name": "keyboard_backspace_black_24dp (1)",
		d: "M4.419,11h13.17l-2.88-2.88a1,1,0,0,1,1.41-1.41l4.59,4.59a1,1,0,0,1,0,1.41l-4.59,4.59a1,1,0,1,1-1.41-1.41L17.589,13H4.419a1,1,0,0,1,0-2Z",
		transform: "translate(-3.419 -6.469)"
	})
});
export { SvgNext as ReactComponent };
